module.exports = __webpack_public_path__ + "static/media/pico.77d57987.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/pico.png
// module id = 57
// module chunks = 0